import { render, staticRenderFns } from "./LaboratoryInternalExam.vue?vue&type=template&id=239576ba"
import script from "./LaboratoryInternalExam.vue?vue&type=script&lang=js"
export * from "./LaboratoryInternalExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports